import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ColorPickerDirective } from '@shuffll/ngx-color-picker';
import { IColorPicked } from '../color-picker/color-picker.component';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-color-pallet',
    templateUrl: './color-pallet.component.html',
    styleUrl: './color-pallet.component.scss',
})
export class ColorPalletComponent implements OnInit, OnDestroy {
    @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
    @ViewChild('picker') picker: ColorPickerDirective;
    @Input({ alias: 'color', required: true }) color: string;
    @Input({ alias: 'key', required: true }) key: string | number;
    @Input({ alias: 'displayBrandColors', required: true }) displayBrandColors: boolean;
    @Input({ alias: 'palletSize', required: false }) palletSize: string = '42px';
    @Output() colorChanged = new EventEmitter<IColorPicked>();
    colorMenuOpen: string | null = null;
    onDestroy$ = new Subject<boolean>();

    constructor() {}

    ngOnInit(): void {}

    closeColorPicker() {
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
    }

    async colorChangedAsync(colorData: IColorPicked) {
        this.colorChanged.emit(colorData);
        this.closeColorPicker();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    protected readonly event = event;
}
